import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../../Assets/Icons/Icon_Close.png';
import Icon_Edit from '../../../Assets/Icons/Icon_Color_Edit.png';
import { Context_UI } from '../../../Contexts/Context_UI';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import UI_Dropdown from '../../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../../Contexts/Context_Templating';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import UI_Divider from '../../ERUMAUI/UI_Divider';
import UI_Form from '../../ERUMAUI/UI_Form';
import UI_Input_Text from '../../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../../ERUMAUI/UI_Input_Text_Long';
import UI_Icon from '../../ERUMAUI/UI_Icons';
import UI_Button from '../../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../../ERUMAUI/UI_UpdatingStatus';

export default function Subwindow_Modal_Schedule_Edit({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Schedule_Information, Schedule_Information_Set, Time_Range_Parse, Schedule_Action_Mode, Status_Parse, Time_Parse, Conflicts, Conflict_Check, Conflict_Recommendation, Reservation, Reservation_Set } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond, Unsaved_Add, Unsaved_Clear } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const [Schedule_Information_Old, Schedule_Information_Old_Set] = useState(Schedule_Information);
    const [Schedule_Information_Loaded, Schedule_Information_Loaded_Set] = useState(false);

    useEffect(() => {
        if (Schedule_Information_Loaded == false) {
            Schedule_Information_Old_Set(Schedule_Information);
            Schedule_Information_Loaded_Set(true);
        }
        if (Schedule_Information) {
            Reservation_Set(Schedule_Information);
        }
    }, []);


    useEffect(() => {
        Fetch(Schedule_Information.Requester.RequesterID)
    }, [Schedule_Information]);

    

    useEffect(() => {
        // Unsaved_Add("Edit schedule");
    }, []);

    const Fetch = async (ID) => {
        const Data = await Account_Fetch_ByID_Basic(ID);
        Account_Set(Data);
    }

    const Confirm = async () => {
        const Cleared = await UI.Input_Evaluate([
            {
                ID: "Edit_Reason",
                Type: "Dropdown",
                AC: "No edit reason specified",
                Prompt: "Specifying a reason is required."
            },
            {
                ID: "Activity_Name",
                Type: "Text",
                AC: "",
                Prompt: "This field is required."
            },
            {
                ID: "Activity_Type",
                Type: "Dropdown",
                AC: "",
                Prompt: "This field is required."
            },
            {
                ID: "Activity_Requester_Type",
                Type: "Text",
                AC: "",
                Prompt: "This field is required."
            }
        ]);
        if (Cleared) {
            Confirmer_Respond(true, {
                Reason: document.getElementById("Edit_Reason").querySelector(".Dropdown_Button").querySelector(".Dropdown_Button_Text").innerText,
                Name: UpdatedSchedule.Name,
                Description: UpdatedSchedule.Description,
                Activity_Type: UpdatedSchedule.Activity.Type,
                Activity_Subject: UpdatedSchedule.Activity.Subject,
                Activity_Attendees: UpdatedSchedule.Activity.Attendees.Names,
                Requester_Type: UpdatedSchedule.Requester.Type,
                Equipment: UpdatedSchedule.Equipment,
                Remarks: UpdatedSchedule.Remarks
            }, true, "Window_ScheduleManagement_Schedule_Edit");
        }
        
    }

    const Cancel = async () => {
        // if (await Unsaved_Clear("Edit schedule")) {
            Confirmer_Respond(false, {}, true, "Window_ScheduleManagement_Schedule_Edit");
        // }
    }

    useEffect(() => {
        const Handler = ({ List_ID, Value }) => {
            switch (List_ID) {
                case "Activity_Type":
                    Handle_Change(["Activity", "Type"], Value);
                    break;
                case "Activity_Requester_Type":
                    Handle_Change(["Requester", "Type"], Value);
                    break;
                case "Activity_Subject":
                    Handle_Change(["Activity", "Subject"], Value);
                    break;
            }
        }

        UI.on("Dropdown_Value_Submitted", Handler);
        return () => {
            UI.off("Dropdown_Value_Submitted", Handler);
        }
    }, [UI]);

    const Handle_Change = (Keys, Value) => {
        const Update = (Previous, Keys, Value) => {
            if (Keys.length === 1) {
                return { ...Previous, [Keys[0]]: Value };
            }
            const [Key_Current, ...Keys_Rest] = Keys;
            return {
                ...Previous,
                [Key_Current]: Update(Previous[Key_Current], Keys_Rest, Value)
            };
        }
        setUpdatedSchedule(Previous => Update(Previous, Keys, Value));
    }

    const [UpdatedSchedule, setUpdatedSchedule] = useState({
        Name: "",
        Description: "",
        Activity: {
            Type: "",
            Subject: "",
            Attendees: {
                Names: []
            }
        },
        Requester: {
            Type: ""
        },
        Equipment: [],
        Remarks: ""
    });

    useEffect(() => {
        if (Schedule_Information?.Time) {
            setUpdatedSchedule({
                Name: Schedule_Information.Name,
                Description: Schedule_Information.Description,
                Activity: {
                    Type: Schedule_Information.Activity.Type,
                    Subject: Schedule_Information.Activity.Subject,
                    Attendees: {
                        Names: Schedule_Information.Activity.Attendees.Names
                    }
                },
                Requester: {
                    Type: Schedule_Information.Requester.Type
                },
                Equipment: Schedule_Information.Equipment,
                Remarks: Schedule_Information.Remarks
            });
        }
    }, [Schedule_Information]);

    useEffect(() => {
        if (!Reservation) return;

        setUpdatedSchedule(prev => {
            // Only override the parts Reservation owns
            return {
                ...prev,
                Equipment: [...(Reservation.Equipment || [])],
                Activity: {
                    ...prev.Activity,
                    Attendees: {
                        ...prev.Activity.Attendees,
                        ...(Reservation.Activity?.Attendees || {})
                    }
                }
            };
        });
    }, [Reservation]);



    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} style={{ height: "calc(80% - 20px)" }}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Edit} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Edit reservation details
                        </h2>

                        <p className='General_Paragraph' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Please specify the details you want to update in this reservation. The applicant of this reservation will be notified of the changes.
                        </p>
                    </div>
                </div>
                <div className='General_Split' Split="2">
                    <UI_Form Composition="ByTwo">
                        {/* <UI_Divider
                            Text="Required fields"
                            DoubleColumns={true}
                        /> */}
                        <span></span>
                        <p className='General_Paragraph' style={{ opacity: "50%" }}>Original: <b>{Schedule_Information.Name}</b></p>
                        <UI_Input_Text
                            Required={true}
                            id="Activity_Name"
                            Input_Placeholder="Name of the activity"
                            Label_Text="Activity name:"
                            Value_Set_Enable={true}
                            Value={UpdatedSchedule.Name}
                            onChange={(e) => Handle_Change(["Name"], e.target.value)}
                        />
                        <span></span>
                        <p className='General_Paragraph' style={{ opacity: "50%" }}>Original: <b>{Schedule_Information.Description}</b></p>
                        <UI_Input_Text_Long
                            id="Activity_Description"
                            Input_Placeholder="A brief description of the activity"
                            Label_Text="Description:"
                            Autoresize="true"
                            Value_Set_Enable={true}
                            Value={UpdatedSchedule.Description}
                            onChange={(e) => Handle_Change(["Description"], e.target.value)} />
                        <span></span>
                        <p className='General_Paragraph' style={{ opacity: "50%" }}>Original: <b>{Schedule_Information.Activity.Type}</b></p>
                        <UI_Dropdown
                            Required={true}
                            id="Activity_Type"
                            Label_Text="Activity type:"
                            InitialTitle="Activity type"
                            Selected={UpdatedSchedule.Activity.Type}
                            Items={Template_List.Activity?.Type} Fill />
                        <span></span>
                        <p className='General_Paragraph' style={{ opacity: "50%" }}>Original: <b>{Schedule_Information.Requester.Type}</b></p>
                        {/* <UI_Dropdown
                            id="Activity_Requester_Type"
                            Label_Text="Requester type:"
                            InitialTitle="No type selected"
                            Selected={UpdatedSchedule.Requester.Type}
                            Items={Template_List.RequesterType} Fill /> */}
                        <UI_Input_Text
                            // Required={true}
                            id="Activity_Requester_Type"
                            Label_Text="Requester type:"
                            InitialTitle="No type selected"
                            Value_Set_Enable={true}
                            Value={UpdatedSchedule.Requester.Type}
                            disabled={true}
                             />

                    </UI_Form>
                    <div>
                        <UI_Form Composition="ByTwo">
                            {/* <UI_Divider
                                Text="Optional fields"
                                DoubleColumns={true}
                            /> */}
                            {/* <UI_Input_Text
                                                    Label_Text="Attendees:" /> */}

                            <span></span>
                            <p className='General_Paragraph' style={{ opacity: "50%" }}>Original: <b>{Schedule_Information.Activity.Subject}</b></p>
                            <UI_Dropdown
                                id="Activity_Subject"
                                Label_Text="Subject:"
                                InitialTitle="Subject"
                                Selected={UpdatedSchedule.Activity.Subject}
                                Items={Template_List.Activity?.Subject} Fill />
                            <label className='Input_Label'>
                                Attendees:
                            </label>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center" }}>
                                <p className='General_Paragraph'>
                                    <b>
                                        {UpdatedSchedule.Activity.Attendees.Names.length === 0 ?
                                            "No attendees set"
                                            :
                                            UpdatedSchedule.Activity.Attendees.Names.length === 1 ?
                                                `${UpdatedSchedule.Activity.Attendees.Names[0]}`
                                                :
                                                `${UpdatedSchedule.Activity.Attendees.Names[0]} + ${UpdatedSchedule.Activity.Attendees.Names.length - 1} others`
                                        }
                                        {/* Soshiro Hoshina + 31 others */}
                                    </b>
                                </p>
                                <UI_Button
                                    Submit={false}
                                    Text="Edit"
                                    Icon={<UI_Icon Name="Add" />}
                                    Icon_Position="Center"
                                    OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Attendees")}
                                />
                            </div>
                            <label className='Input_Label'>
                                Equipment:
                            </label>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center" }}>
                                <p className='General_Paragraph'>
                                    <b>
                                        {UpdatedSchedule.Equipment.length === 0 ?
                                            "No equipments set"
                                            :
                                            UpdatedSchedule.Equipment.length === 1 ?
                                                `${UpdatedSchedule.Equipment[0]}`
                                                :
                                                `${UpdatedSchedule.Equipment[0]} + ${UpdatedSchedule.Equipment.length - 1} others`
                                        }
                                        {/* Projector + 2 others */}
                                    </b>
                                </p>
                                <UI_Button
                                    Submit={false}
                                    Text="Edit"
                                    Icon={<UI_Icon Name="Add" />}
                                    Icon_Position="Center"
                                    OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Equipment")}
                                />
                            </div>
                            <UI_Input_Text_Long
                                id="Activity_Remarks"
                                Input_Placeholder="Additional remarks"
                                Label_Text="Additional remarks:"
                                Autoresize="true"
                                Value_Set_Enable={true}
                                Value={UpdatedSchedule.Remarks}
                                onChange={(e) => Handle_Change(["Remarks"], e.target.value)} />
                        </UI_Form>
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Pick an edit reason
                            </p>
                            <UI_Dropdown id="Edit_Reason" Items={Template_List.Reason.Request_Edited} InitialTitle="No edit reason specified" />
                        </div>
                    </div>

                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Positive" onClick={Confirm}>
                    Save changes
                </button>

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
